import { AppSetting } from '../AppSetting';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { BaseService } from '../Service/BaseService';
import { AppSettingApi } from '../AppSettingApi';
import { HttpHeaders } from '@angular/common/http';



/**
 * HealthInsureDAO
 * 認証系DAO
 */
export class HealthInsureDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}

	/**
	 * getHealthInsure
	 * 保険証の簡易データ一覧取得
	 * @returns 保険証の簡易データ
	 */
	public async getHealthInsure() {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.HEALTH_INSURE_LIST, request);
		return ret;

	}

	/**
	 * uploadHealthInsure
	 * 保険証のアップロード
	 * @param display_name ファイル名
	 * @param date アップロード日
	 * @param upload_file アップロードファイル
	 * @returns 保存データ
	 */
	public async uploadHealthInsure(display_name: string, date: string, upload_file: any) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		// JSON形式での送信ではないので、optionを変更する
		const httpOptions = {
			headers: new HttpHeaders({
			})
		};

		// FileDataをJSONで送信できないため、FromDataに変換して送信する
		const formData = new FormData();
		formData.append('t', this.token);
		formData.append('display_name', display_name);
		formData.append('upload_file', upload_file);
		formData.append('date', date);


		const ret = await this.postRequest(AppSettingApi.HEALTH_INSURE_UPLOAD, formData, httpOptions);
		return ret;

	}

	// 更新
	/**
	 * changeHealthInsure
	 * ファイルの更新を行う
	 * @param file_info_id ファイルID
	 * @param display_name 表示名
	 * @param date 変更日
	 * @param upload_file アップロードファイル
	 * @returns 保存データ
	 */
	public async changeHealthInsure(file_info_id: number, display_name: string, date: string, upload_file: any) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		// JSON形式での送信ではないので、optionを変更する
		const httpOptions = {
			headers: new HttpHeaders({
			})
		};

		// FileDataをJSONで送信できないため、FromDataに変換して送信する
		const formData = new FormData();
		formData.append('t', this.token);
		formData.append('display_name', display_name);
		formData.append('upload_file', upload_file);
		formData.append('file_info_id', file_info_id.toString());
		formData.append('date', date);

		const ret = await this.postRequest(AppSettingApi.HEALTH_INSURE_UPDATE, formData, httpOptions);
		return ret;

	}

	/**
	 * deleteHealthInsure
	 * アップロード済みのファイルを削除する
	 * @param file_info_id ファイルID
	 * @returns void
	 */
	public async deleteHealthInsure(file_info_id: number) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token,
			file_info_id
		};

		const ret = await this.postRequest(AppSettingApi.HEALTH_INSURE_DELETE, request);
		return ret;

	}

}
